import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [favIds, setFavIds] = useState([]);
  const [notes, setNotes] = useState({});
  const approved = user && (user.role === "admin" || user.status === "approved");

  const refresh = useCallback(async () => {
    if (!approved) { setFavIds([]); setNotes({}); return; }
    try {
      const { data } = await api.get("/favorites");
      setFavIds(data.product_ids);
      setNotes(data.notes || {});
    } catch {}
  }, [approved]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (productId) => {
    const { data } = await api.put(`/favorites/${productId}`);
    setFavIds(data.product_ids);
    return data.favorite;
  };

  const setNote = async (productId, note) => {
    const { data } = await api.put(`/favorites/${productId}/note`, { note });
    setNotes(data.notes || {});
  };

  return (
    <FavoritesContext.Provider value={{ favIds, notes, toggle, setNote, count: favIds.length, refresh }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
